<script setup lang="ts">
import Tag from 'primevue/tag';

import { useNetworkStatus } from '../composables/useNetworkStatus';

const { isOnline } = useNetworkStatus();
</script>

<template>
  <Tag v-auto-animate v-if="isOnline" severity="success" value="Online" rounded></Tag>
  <Tag v-auto-animate v-else severity="danger" value="Offline" rounded></Tag>
</template>
